// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Bbw_","disabled":"Button_disabled__IYKFV","open":"Button_open__6vi7V","alt":"Button_alt__2F1yH"};